import React from "react";
import { EditButton, List, TextField } from "react-admin";
import BulkActionButtons from "../../../bookmaker-deals/BulkActionsButtons";
import BookmakerField from "../../../bookmaker-deals/fields/BookmakerField";
import BookmakerTypeField from "../../../bookmaker-deals/fields/BookmakerTypeField";
import EventField from "../../../bookmaker-deals/fields/EventField";
import ItemsField from "../../../bookmaker-deals/fields/ItemsField";
import UserField from "../../../bookmaker-deals/fields/UserField";
import ResponsiveList from "../../../components/lists/ResponsiveList";
import { useListStyles } from "../../../components/lists/useStyles";
import { getCommonListProps } from "./";

const DealsListField = (props) => {
	const classes = useListStyles();
	return (
		<List
			resource="bookmaker-deals"
			basePath="/bookmaker-deals"
			classes={classes}
			{...getCommonListProps(props)}
			bulkActionButtons={<BulkActionButtons />}
		>
			<ResponsiveList>
				<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
				<EventField
					source="event.name"
					label="resources.bookmaker-deals.fields.event.name"
				/>
				<BookmakerTypeField
					source="bookmaker_type.name"
					label="resources.bookmaker-deals.fields.bookmaker_type.name"
				/>
				<BookmakerField
					source="bookmaker.name"
					label="resources.bookmaker-deals.fields.bookmaker.name"
				/>
				<UserField
					source="user.name"
					label="resources.bookmaker-deals.fields.user.name"
				/>
				<ItemsField
					source="items"
					label="resources.bookmaker-deals.fields.items"
				/>
				<EditButton />
			</ResponsiveList>
		</List>
	);
};

export default DealsListField;
